// extracted by mini-css-extract-plugin
module.exports = {"separatorWrapper":"Separator_separatorWrapper__3OMLJ","separator":"Separator_separator__36oeh"};